<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center justify-content-between">
              <h6 class="mb-0">Cierres de caja</h6>
              <button type="button" class="btn btn-sm btn-outline-secondary" @click="load">
                <i class="fas fa-sync-alt me-1"></i> Actualizar
              </button>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div v-if="loading" class="text-center py-5">
              <i class="fas fa-spinner fa-spin fa-2x text-secondary"></i>
            </div>

            <div v-else-if="sessions.length === 0" class="text-center py-5 text-secondary text-sm">
              No hay cierres de caja registrados.
            </div>

            <div v-else class="table-responsive p-0 px-3">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">#</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Usuario</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Apertura</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cierre</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Monto inicial</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ventas total</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ventas efectivo</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Esperado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Contado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Diferencia</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Notas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="s in sessions" :key="s.id">
                    <td class="text-xs text-secondary">{{ s.id }}</td>
                    <td class="text-xs font-weight-bold">{{ s.user?.name || '—' }}</td>
                    <td class="text-xs">{{ formatDateTime(s.opened_at) }}</td>
                    <td class="text-xs">
                      <template v-if="s.closed_at">{{ formatDateTime(s.closed_at) }}</template>
                      <span v-else class="badge badge-sm bg-success">Abierta</span>
                    </td>
                    <td class="text-center text-xs">{{ money(s.opening_amount) }}</td>
                    <td class="text-center text-xs">{{ money(s.total_sales) }}</td>
                    <td class="text-center text-xs">{{ money(s.cash_sales) }}</td>
                    <td class="text-center text-xs">{{ money(s.expected_amount) }}</td>
                    <td class="text-center text-xs">{{ money(s.closing_amount) }}</td>
                    <td class="text-center">
                      <template v-if="s.closed_at">
                        <span
                          class="badge badge-sm"
                          :class="difference(s) === 0 ? 'bg-success' : (difference(s) > 0 ? 'bg-info text-dark' : 'bg-danger')"
                        >
                          {{ difference(s) > 0 ? '+' : '' }}{{ money(difference(s)) }}
                        </span>
                      </template>
                      <span v-else class="text-secondary text-xs">—</span>
                    </td>
                    <td class="text-xs text-secondary" style="max-width: 200px;">{{ s.notes || '—' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import posService from '@/services/pos.service';

export default {
  name: 'CashSessions',
  data() {
    return {
      sessions: [],
      loading: true,
    };
  },
  methods: {
    money(val) {
      return '$ ' + (parseFloat(val) || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    formatDateTime(val) {
      if (!val) return '—';
      return new Date(val).toLocaleString('es-CO', { dateStyle: 'short', timeStyle: 'short' });
    },
    difference(s) {
      return Math.round(((parseFloat(s.closing_amount) || 0) - (parseFloat(s.expected_amount) || 0)) * 100) / 100;
    },
    async load() {
      this.loading = true;
      try {
        const res = await posService.getCashSessions();
        this.sessions = res.data?.data || res.data || [];
      } catch (e) {
        console.error('Error cargando cierres de caja:', e);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.load();
  },
};
</script>
